<mat-selection-list #shoes [multiple]="false">
    <mat-list-option (click)="openDialog('others')">共通</mat-list-option>
    <mat-list-option *ngFor="let menuKey of getOrderedVisibleMenus()" 
                     (click)="openDialog(menuKey)">
        {{getMenuLabel(menuKey)}}
    </mat-list-option>
</mat-selection-list>
